import {
  getUser,
  type Langs,
  setUserData,
  setUserPoints,
  type UserState,
  type Countries,
  setUserCountry,
  setUserLanguage
} from '@/redux/user';

import Store from '@/redux';
import { MCD } from '@/services/app';

const setDocumentLanguage = (user: UserState = getUser(Store.getState())) => {
  let { country = '' } = user;
  const { language = '' } = user;
  country &&= `-${country.slice(-2).toLocaleUpperCase()}`;
  document.documentElement.setAttribute('lang', `${language}${country}`);
};

export const checkUserData = async () => {
  try {
    const data = (await MCD.getUserData()) as UserState;
    Store.dispatch(setUserData(data));
    console.info('User Data:', data);
    return data;
  } catch (error) {
    console.error('"checkUserData" error:', error);
    throw error;
  }
};

export const checkUserPoints = async () => {
  try {
    const points = await MCD.getUserPoints();
    Store.dispatch(setUserPoints(points));
    console.info('User Points:', points);
    return points;
  } catch (error) {
    console.error('"checkUserPoints" error:', error);
    throw error;
  }
};

export const checkUserCountry = async () => {
  try {
    const country = (
      await MCD.getUserCountry()
    ).toLocaleLowerCase() as Countries;

    Store.dispatch(setUserCountry(country));
    console.info('User Country:', country);
    setDocumentLanguage();
    return country;
  } catch (error) {
    console.error('"checkUserCountry" error:', error);
    throw error;
  }
};

export const checkUserLanguage = async () => {
  const rtlDirLangs = new Set(['ar', 'az', 'dv', 'fa', 'he', 'ku', 'ur']);

  try {
    let language = (
      await MCD.getUserLanguage()
    ).toLocaleLowerCase() as Langs;

    const countrySeparator = language.indexOf('-');
    const end = countrySeparator > -1 && countrySeparator;

    language = language.slice(0, end || undefined) as Langs;
    const dir = (rtlDirLangs.has(language) && 'rtl') || 'ltr';

    document.documentElement.setAttribute('dir', dir);
    Store.dispatch(setUserLanguage(language));
    console.info('User Language:', language);

    setDocumentLanguage();
    return language;
  } catch (error) {
    console.error('"checkUserLanguage" error:', error);
    throw error;
  }
};
